<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.guestbookAdd") }}</h3>
            </div>
            <div class="card-body p-0">
                <div class="p-4">
                    <GuestbookForm ref="guestbookForm" :guestbook="guestbookCopy" @submit="addGuestbook" />
                </div>
            </div>
        </div>


        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5" @click="submitForm">{{ $t("utils.save") }}</button>
        </div>
    </div>
</template>

<script>
    import GuestbookForm from '@/components/GuestbookForm.vue';
    import { formatForBackend } from '@/utils/date';

    export default {
        components: {
            GuestbookForm,
        },
        data() {
            return {
                guestbookCopy: {},
            }
        },
        created() {
            const copy = this.$store.getters.getCopyRecord;

            if (copy) {
                this.guestbookCopy = copy.guestbook;
                this.$store.commit("clearCopyRecord");
            }
        },
        methods: {
            submitForm() {
                if (this.$refs.guestbookForm?.submitForm) {
                    this.$refs.guestbookForm.submitForm();
                }
            },
            addGuestbook(data) {
                const formData = {
                    name: data.name,
                    company: data.company,
                    cardNumber: data.cardNumber,
                    cardType: data.cardType,
                    expectedFrom: formatForBackend(data.expectedFrom),
                    expectedTo: formatForBackend(data.expectedTo),
                    status: data.status,
                    isTrained: data.isTrained,
                };

                this.$store.getters.api.post(`/${this.$route.params.slug}/guestbooks/add`, formData)
                .then(response => {
                    this.$router.push({
                        name: "guestbookDetailView",
                        params: {
                            slug: this.$route.params.slug,
                            id: response.data.id,
                        }
                    });
                })
                .catch(error => {
                    console.error("Error adding guestbook", error);
                });
            },
        }
    }
</script>

